import { SPECIAL_REQUESTS_STATE } from './constants'

export const getIsFetching = hash => state =>
  state[SPECIAL_REQUESTS_STATE]?.bookings[hash]?.isFetching

export const getStatus = hash => state => state[SPECIAL_REQUESTS_STATE]?.bookings[hash]?.status
